import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ModalController} from '@ionic/angular';
import {BaseModalComponent, LoadingService, Menu, MenuModifier, MenuModifierService, ToastService} from 'brewbill-lib';

@Component({
    selector: 'bb-edit-menu-modifier',
    templateUrl: './edit-menu-modifier.component.html',
    styleUrls: ['./edit-menu-modifier.component.scss'],
})
export class EditMenuModifierComponent extends BaseModalComponent implements OnInit {

    formGroup: FormGroup = new FormGroup({});
    @Input() menuModifier: MenuModifier;
    @Input() menu: Menu;
    @Input() selectionOption = false;

    constructor(
        modalController: ModalController,
        private menuModifierService: MenuModifierService,
        private toastService: ToastService,
        private loadingService: LoadingService,
        private formBuilder: FormBuilder
    ) {
        super(modalController);
    }

    ngOnInit() {
        this.menuModifier = this.menuModifier == null ? new MenuModifier() : this.menuModifier;

        this.formGroup = this.formBuilder.group({
            id: this.menuModifier.id,
            parentId: this.menu.id,
            name: [this.menuModifier.name, Validators.required],
            description: this.menuModifier.description,
            selectionOption: this.selectionOption
        });
    }

    async onSubmit() {
        this.loadingService.present();
        const ml: MenuModifier = new MenuModifier(this.formGroup.value);

        if (ml.id != null) {
            this.menuModifierService.update(ml).subscribe(
                (menuModifier: MenuModifier) => {
                    this.loadingService.dismiss();
                    this.close(menuModifier);
                }, error => {
                    if (error.status === 422) {
                        this.toastService.error('The modifier is out of sync from a previous change. Please refresh to make changes.');
                    }
                    this.close();
                }
            );
        } else {
            this.menuModifierService.create(ml).subscribe(
                async (menuModifier: MenuModifier) => {
                    this.loadingService.dismiss();
                    await this.close(menuModifier);
                }
            );
        }
    }
}
